module.exports = __webpack_public_path__ + "static/media/slick-carousel-preloader-primary.440cd5b3.svg";